export const AD_NETWORKS = 'ad_networks' as const;
export const AGENCY_TAGGED_DATA = 'agency_tagged_data' as const;
export const AGGREGATE_DATA = 'aggregate_data' as const;
export const APP_LEVEL_SETTINGS = 'app_level_settings' as const;
export const AUDIENCE_BUILDER = 'audience_builder' as const;
export const CHANNEL_LEVEL_SETTINGS = 'channel_level_settings' as const;
export const EXPORT = 'export' as const;
export const FRAUD_MANAGER = 'fraud_manager' as const;
export const FRAUD_REPORTING = 'fraud_reporting' as const;
export const FRAUD_SETTINGS_AND_DATA = 'fraud_settings_and_data' as const;
export const LINK_LEVEL_SETTINGS = 'link_level_settings' as const;
export const LINK_TEMPLATE_SETTINGS = 'link_template_settings' as const;
export const LOCATION = 'location' as const;
export const MOBILE_SEARCH = 'mobile_search' as const;
export const REVENUE_DATA = 'revenue_data' as const;
export const SENSITIVE_DATA = 'sensitive_data' as const;
export const TEAM_ACCESS = 'team_access' as const;
export const BRANCH_ACCOUNT_SETTINGS = 'branch_account_settings' as const;
